import { useEffect, useState } from 'react';
import { api, timeAgo } from '../api.js';
import { UserChip } from '../components/UserChip.jsx';
import { Pagination } from '../components/Pagination.jsx';
import { useGuild } from './GuildLayout.jsx';

const PAGE = 50;

export default function Warnings() {
  const { guildId } = useGuild();
  const [data, setData] = useState(null);
  const [offset, setOffset] = useState(0);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    setData(null);
    api.warnings(guildId, `?limit=${PAGE}&offset=${offset}`).then(setData);
  }, [guildId, offset]);

  async function handleDelete(id) {
    if (!confirm('Delete this warning?')) return;
    await api.deleteWarning(guildId, id);
    // Refresh current page
    api.warnings(guildId, `?limit=${PAGE}&offset=${offset}`).then(setData);
  }

  if (!data) return <div className="empty">Loading…</div>;

  // Client-side filter only narrows the current page; for whole-server search,
  // direct them to the audit search page.
  const filtered = filter
    ? data.warnings.filter(w => w.user_id.includes(filter) || (w.reason || '').toLowerCase().includes(filter.toLowerCase()))
    : data.warnings;

  return (
    <>
      <h1>Warnings</h1>
      <p className="subtitle">{data.total.toLocaleString()} warning{data.total === 1 ? '' : 's'} on record. Filter narrows the current page; for whole-server search use <a href={`/g/${guildId}/audit`}>Audit search</a>.</p>
      <div className="field">
        <input placeholder="Filter current page by user ID or reason text…" value={filter} onChange={e => setFilter(e.target.value)} />
      </div>
      {!filtered.length ? (
        <div className="empty">No warnings{filter ? ' match the filter' : ''} on this page.</div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead>
              <tr><th>When</th><th>User</th><th>Moderator</th><th>Reason</th><th></th></tr>
            </thead>
            <tbody>
              {filtered.map(w => (
                <tr key={w.id}>
                  <td title={new Date(w.created_at * 1000).toLocaleString()} style={{ whiteSpace: 'nowrap' }}>{timeAgo(w.created_at)}</td>
                  <td><UserChip guildId={guildId} userId={w.user_id} size={20} /></td>
                  <td><UserChip guildId={guildId} userId={w.moderator_id} size={20} /></td>
                  <td>{w.reason || <span className="dim">—</span>}</td>
                  <td><button className="ghost" onClick={() => handleDelete(w.id)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Pagination total={data.total} limit={PAGE} offset={offset} onChange={setOffset} />
    </>
  );
}
